(() => {
  const toInt = (v) => {
    const n = parseInt(String(v ?? "").trim(), 10);
    return Number.isFinite(n) ? n : null;
  };

  const getSteps = (quantityInputEl) => {
    const q1 = toInt(quantityInputEl.dataset.bqQ1);
    const q2 = toInt(quantityInputEl.dataset.bqQ2);
    const q3 = toInt(quantityInputEl.dataset.bqQ3);
    if (!q1 || !q2 || !q3) return null;

    const steps = [q1, q2, q3].sort((a, b) => a - b);
    if (steps[0] <= 0 || steps[0] === steps[1] || steps[1] === steps[2]) return null;

    return steps; // [menor, meio, maior]
  };

  const nextQty = (current, [q1, q2, q3]) => {
    const cur = Math.max(0, toInt(current) ?? 0);

    if (cur <= 0) return q1;
    if (cur < q1) return q1;
    if (cur < q2) return q2;
    if (cur < q3) return q3;

    const S = q1 + q2 + q3;
    const delta = cur - q3;
    const r = ((delta % S) + S) % S;

    if (r < q1) return cur + (q1 - r);
    if (r < q1 + q2) return cur + (q1 + q2 - r);
    return cur + (S - r);
  };

  const prevQty = (current, [q1, q2, q3]) => {
    const cur = Math.max(0, toInt(current) ?? 0);

    if (cur <= q1) return 0;   // remove
    if (cur <= q2) return q1;
    if (cur <= q3) return q2;

    const S = q1 + q2 + q3;
    const delta = cur - q3;
    const r = ((delta % S) + S) % S;

    if (r === 0) return cur - q3;
    if (r <= q1) return cur - r;
    if (r <= q1 + q2) return cur - (r - q1);
    return cur - (r - (q1 + q2));
  };

  const clickNativeRemove = (qi, input) => {
    const row =
      qi.closest("tr.cart-item") ||
      qi.closest("tr") ||
      qi.closest(".cart-item") ||
      qi.closest("[id^='CartItem-']") ||
      qi.closest("[id^='CartDrawer-Item-']");

    const candidate =
      row?.querySelector("cart-remove-button button") ||
      row?.querySelector("cart-remove-button a") ||
      document.querySelector(`cart-drawer cart-remove-button[data-index="${input?.dataset?.index}"] button`) ||
      document.querySelector(`cart-items cart-remove-button[data-index="${input?.dataset?.index}"] a`);

    if (!candidate) return false;
    candidate.click();
    return true;
  };

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("quantity-input .quantity__button");
      if (!btn) return;

      const qi = btn.closest("quantity-input");
      if (!qi) return;

      // ✅ Agora funciona em cart-drawer OU /cart
      const inDrawer = !!qi.closest("cart-drawer");
      const inCartPage = !!qi.closest("cart-items") || !!qi.closest("#main-cart-items");
      if (!inDrawer && !inCartPage) return;

      const steps = getSteps(qi);
      if (!steps) return; // sem bundle tiers => comportamento padrão

      const input = qi.querySelector("input.quantity__input");
      if (!input) return;

      const name = btn.getAttribute("name");
      const isPlus = name === "plus";
      const isMinus = name === "minus";
      if (!isPlus && !isMinus) return;

      // bloqueia o handler padrão do tema
      e.preventDefault();
      e.stopImmediatePropagation();

      const current = toInt(input.value) ?? 0;
      const desired = isPlus ? nextQty(current, steps) : prevQty(current, steps);
      if (desired === current) return;

      if (desired === 0) {
        if (clickNativeRemove(qi, input)) return;

        // fallback (bem raro)
        input.value = "0";
        input.dispatchEvent(new Event("change", { bubbles: true }));
        return;
      }

      input.value = String(desired);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    },
    true
  );
})();
